export default "__VITE_ASSET__3495d38b__"